import styled, { css } from 'styled-components'

export const Container = styled.div<any>`
  max-width: 1120px;
  margin: 36px auto;
  
  ${props => props.noMarginTop && css`
    margin-top: 0;
  `}
  
  ${props => props.full && css`
    max-width: 100%;
    margin: 0;
  `}
  ${props => props.noprint && css `
    @media print {
      display: none;
    }
  `}
`